import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Checkbox } from '@one-thd/sui-atomic-components';
import { SweepstakesDrawer } from './SweepstakesDrawer';
import { SweepstakesMarkdown } from '../SweepstakesMarkdown';
import { SWEEPSTAKES_CONSTANTS } from '../../../core/Constants';
import { SWEEPSTAKES_OPT_IN_CONTENT } from '../../../core/Data/SweepstakesMockData';

export const SweepstakesOptInDrawer = ({
  isOpen,
  onClose,
  onTakeSurvey,
  heroImage,
  isLoading,
  hasError,
}) => {
  const [termsChecked, setTermsChecked] = useState(false);
  const [associateChecked, setAssociateChecked] = useState(false);

  const handleTakeSurvey = () => {
    if (onTakeSurvey && termsChecked && associateChecked) {
      onTakeSurvey();
    }
  };

  const isButtonDisabled = !termsChecked || !associateChecked;

  const footerContent = (
    <div className="sui-space-y-2">
      <div>
        <div className="sui-flex sui-items-center sui-gap-3">
          <Checkbox
            checked={termsChecked}
            onChange={(event) => setTermsChecked(event.target.checked)}
            data-testid="terms-checkbox"
          />
          <div className="sui-flex-1 sui-leading-none">
            <Typography variant="body-sm">
              I agree to the{' '}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                className="sui-text-brand sui-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms & Conditions
              </a>
              {' and '}
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a
                href="#"
                className="sui-text-brand sui-underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </Typography>
          </div>
        </div>
        <div className="sui-flex sui-items-center sui-gap-3">
          <Checkbox
            checked={associateChecked}
            onChange={(event) => setAssociateChecked(event.target.checked)}
            data-testid="associate-checkbox"
          />
          <div className="sui-flex-1 sui-leading-none">
            <Typography variant="body-sm">
              I am <span className="sui-font-bold sui-underline">not</span> an active Home Depot associate
            </Typography>
          </div>
        </div>
      </div>
      <Button
        variant="primary"
        fullWidth
        onClick={handleTakeSurvey}
        disabled={isButtonDisabled}
        data-testid="sweepstakes-take-survey-button"
      >
        {SWEEPSTAKES_OPT_IN_CONTENT.ctaTitle}
      </Button>
    </div>
  );

  return (
    <SweepstakesDrawer
      isOpen={isOpen}
      onClose={onClose}
      drawerTitle={SWEEPSTAKES_CONSTANTS.DRAWER_TITLES.SWEEPSTAKES_OPT_IN}
      sweepstakesTitle={SWEEPSTAKES_OPT_IN_CONTENT.title}
      heroImage={heroImage}
      footerContent={footerContent}
      isLoading={isLoading}
      hasError={hasError}
      testId="sweepstakes-opt-in-drawer"
    >
      <div className="sui-space-y-4" data-testid="sweepstakes-opt-in-content">
        <SweepstakesMarkdown markdownText={SWEEPSTAKES_OPT_IN_CONTENT.content} />
      </div>
    </SweepstakesDrawer>
  );
};

SweepstakesOptInDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onTakeSurvey: PropTypes.func,
  heroImage: PropTypes.string,
  isLoading: PropTypes.bool,
  hasError: PropTypes.bool,
};

SweepstakesOptInDrawer.defaultProps = {
  onTakeSurvey: null,
  heroImage: null,
  isLoading: false,
  hasError: false,
};